// Events
import { THEME_WISHLIST_UPDATED } from 'events';
import Cookies from 'js-cookie';
// Lib
import Wishlist from 'lib/wishlist';
import { component } from 'picoapp';

import { heart, heartFilled } from 'utils/icons';
// Utils
import { clear, stringToNode } from 'utils/node';

export default component(async (node, ctx) => {
  const { main } = node.dataset;
  const handles = JSON.parse(node.dataset.handles);

  const getLooks = () => {
    const data = Cookies.get('wishlist-looks');

    if (data) {
      return JSON.parse(data);
    }

    return [];
  };

  const addedLooks = getLooks();

  const saveLooks = () => {
    Cookies.set('wishlist-looks', JSON.stringify(addedLooks), {
      expires: 365,
    });
  };

  const toggle = () => {
    const index = addedLooks.indexOf(main);

    if (index > -1) {
      addedLooks.splice(index, 1);
    } else {
      addedLooks.push(main);
    }

    saveLooks();
  };

  const setIcon = (initial = false) => {
    clear(node);

    if (addedLooks.indexOf(main) > -1) {
      node.innerHTML = heartFilled;

      if (!initial) {
        const pulse = stringToNode(heartFilled);
        pulse.classList.add(
          'animate-ping-once',
          'absolute',
          'top-1/2',
          'left-1/2',
          'transform',
          '-translate-x-1/2',
          '-translate-y-1/2',
          'origin-bottom-right',
        );
        node.appendChild(pulse);
      }
    } else {
      node.innerHTML = heart;
    }
  };

  setIcon(true);

  node.addEventListener('click', (event) => {
    event.preventDefault();

    toggle();

    if (addedLooks.indexOf(main) > -1) {
      handles.forEach((itemHandle) => {
        Wishlist.add(itemHandle);
      });
    } else {
      handles.forEach((itemHandle) => {
        Wishlist.remove(itemHandle);
      });
    }

    setIcon();

    ctx.emit(THEME_WISHLIST_UPDATED, { wishlist: Wishlist.items });
  });
});
